import { devHandlers } from './handlers';

/**
 * Starts the MSW service worker in the browser, for development only.
 *
 * Gated on `import.meta.env.DEV` AND `VITE_ENABLE_MOCKS`, and `msw/browser` is
 * behind a dynamic import so the package is never pulled into a production
 * bundle. A payments app that could accidentally ship a mock backend is a
 * payments app that could show someone a fabricated balance.
 *
 * Unmatched requests pass through to the real API, so the mocked crypto
 * endpoints and a locally running Novix.Api can be used at the same time.
 */
export async function startMockServiceWorker(): Promise<void> {
  if (!import.meta.env.DEV || import.meta.env.VITE_ENABLE_MOCKS !== 'true') return;

  const { setupWorker } = await import('msw/browser');
  await setupWorker(...devHandlers).start({
    onUnhandledRequest: 'bypass',
    quiet: true
  });
}
